// extracted by mini-css-extract-plugin
module.exports = {"paymentPage":"ConfirmPayment_paymentPage__3jfwG","confirmContainer":"ConfirmPayment_confirmContainer__xqK9P"};